/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import CKEditor from 'ckeditor4-react'
import {
  Button, Collapse,
  FormControl, FormControlLabel,
  FormHelperText,
  InputAdornment,
  InputLabel, MenuItem, Radio, RadioGroup, Select, Switch,
  TextField
} from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik'
import { serviceFormValidation } from '../../../../../utils/validationSchema'
import { FormLoader } from '../../../../Loader/FormLoader'
import { ButtonLoader } from '../../../../Loader/ButtonLoader'
import { SearchLoader } from '../../../../Loader/SearchLoader'
import { ServiceConsumer } from '../../../../../ServiceContext'
import { NamedRoutes } from '../../../../../routes'
import { useStyles } from './Styles'
import { LanguageConsumer } from '../../../../../LanguageContext'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import { AuthenticatedUserConsumer } from '../../../../../AuthenticatedUserContext'
import AllowedTaxField from '../../PlanEditContent/PlanForm/AllowedTaxField'
import TopUps from './TopUps'

const ServiceForm = ({ currentDate, onSubmit }) => {
  const classes = useStyles()
  const intl = useIntl()
  const history = useHistory()
  const [isLoading, setIsLoading] = React.useState(true)
  const [quotaPrices, setQuotaPrices] = React.useState([])
  const [quotaPricesValidArr, setQuotaPricesValidArr] = React.useState([])
  const [quotaPricesCompleted, setQuotaPricesCompleted] = React.useState(true)
  const [quotaPricesDuplicated, setQuotaPricesDuplicated] = React.useState([])
  let priceDurations = [
    { key: 'monthly', label: <FormattedMessage id='Services.List.Table.Prices.monthly'/> },
    { key: 'quarterly', label: <FormattedMessage id='Services.List.Table.Prices.quarterly'/> },
    { key: 'midterm', label: <FormattedMessage id='Services.List.Table.Prices.midterm'/> },
    { key: 'annually', label: <FormattedMessage id='Services.List.Table.Prices.annually'/> }
  ]
  const [topUpsCompleted, setTopUpsCompleted] = React.useState(true)
  const ServiceForm = useFormik({
    initialValues: {
      title: currentDate.title || '',
      description: currentDate.description || '',
      category_id: currentDate.category ? currentDate.category.id : '',
      handler_name: currentDate.handler_name || '',
      active: !!Object.keys(currentDate).length ? currentDate.active : true,
      price_monthly: !!currentDate?.prices?.length ? (parseFloat((currentDate.prices.filter((price) => price.price_duration === 'monthly'))?.shift()?.price) >= 0 ? parseFloat((currentDate.prices.filter((price) => price.price_duration === 'monthly'))?.shift()?.price) : '') : '',
      price_quarterly: !!currentDate?.prices?.length ? (parseFloat((currentDate.prices.filter((price) => price.price_duration === 'quarterly'))?.shift()?.price) >= 0 ? parseFloat((currentDate.prices.filter((price) => price.price_duration === 'quarterly'))?.shift()?.price) : '') : '',
      price_midterm: !!currentDate?.prices?.length ? (parseFloat((currentDate.prices.filter((price) => price.price_duration === 'midterm'))?.shift()?.price) >= 0 ? parseFloat((currentDate.prices.filter((price) => price.price_duration === 'midterm'))?.shift()?.price) : '') : '',
      price_annually: !!currentDate?.prices?.length ? (parseFloat((currentDate.prices.filter((price) => price.price_duration === 'annually'))?.shift()?.price) >= 0 ? parseFloat((currentDate.prices.filter((price) => price.price_duration === 'annually'))?.shift()?.price) : '') : '',
      is_quota_based: currentDate.is_quota_based || false,
      quota_unit: currentDate.quota_unit || '',
      quotaPrices: currentDate?.prices || [],
      topups: currentDate?.topups || [],
      allowed_taxes: !!currentDate?.allowed_tax_types ? 'custom' : '',
      allowed_taxes_monthly: currentDate?.allowed_tax_types?.monthly || [],
      allowed_taxes_quarterly: currentDate?.allowed_tax_types?.quarterly || [],
      allowed_taxes_midterm: currentDate?.allowed_tax_types?.midterm || [],
      allowed_taxes_annually: currentDate?.allowed_tax_types?.annually || []
    },
    validateOnMount: true,
    validateOnBlur: false,
    validateOnChange: true,
    validationSchema: serviceFormValidation,
    onSubmit: ((values, actions) => {
      onSubmit(values, actions)
    })
  })

  const prepareQuotaPrices = () => {
    if (!!currentDate?.prices?.length) {
      let newPrices = [], validations = [], isCompleted = true
      currentDate.prices.forEach((price, index) => {
        newPrices.push({
          // id: price?.id || index,
          price: price?.price ? parseFloat(price?.price)?.toString() : '',
          price_duration: price?.price_duration || '',
          quota: price?.quota ? parseFloat(price?.quota)?.toString() : ''
        })
        Object.keys(price).forEach(fieldName => {
          if (!price[fieldName]) {
            isCompleted = false
            if (!!validations[index] && !!Object.keys(validations[index]).length) {
              validations[index][fieldName] = true
            } else {
              validations[index] = {}
              validations[index][fieldName] = true
            }
          }
        })
      })
      setQuotaPrices(newPrices)
      setQuotaPricesValidArr(validations)
      setQuotaPricesCompleted(isCompleted)
    }
  }
  React.useEffect(() => {
      if (!!ServiceForm?.values?.is_quota_based) {
        if (!!currentDate?.prices?.length) {
          prepareQuotaPrices()
        } else if (!quotaPrices?.length) {
          tabsAddNewRecord()
        }
      } else {
        setTopUpsCompleted(true)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [ServiceForm?.values?.is_quota_based])

  const checkAllDataCompleted = (currentData) => {
    let valid = true
    let data = !!currentData ? currentData : quotaPrices
    let duplicated = []
    if (!!data.length) {
      data.forEach((item) => {
        if ((!item.price && item.price !== 0) || (!item.quota && item.quota !== 0) || !item.price_duration) {
          valid = false
        }
      })
      let valueArr = data.map(item => [item.quota, item.price_duration].join('-'))
      duplicated = valueArr.map((item, idx) => valueArr.indexOf(item) !== idx)
      setQuotaPricesDuplicated(duplicated)
    }
    setQuotaPricesCompleted(valid)

    if (!!valid && !duplicated?.filter(dup => !!dup).length) {
      ServiceForm.setFieldValue('quotaPrices', data)
    }

    return valid
  }

  const handleQuotaPriceRecordChange = (e, valueIndex, fieldName) => {
    if (!!e) {
      e.preventDefault()
      e.stopPropagation()
    }

    let validations = [...quotaPricesValidArr]

    if (!e?.target?.value && e?.target?.value !== 0) {
      if (!!validations[valueIndex] && !!Object.keys(validations[valueIndex]).length) {
        validations[valueIndex][fieldName] = true
      } else {
        validations[valueIndex] = {}
        validations[valueIndex][fieldName] = true
      }
    } else {
      if (!!validations.length && !!validations[valueIndex] && !!Object.keys(validations[valueIndex]).length && !!validations[valueIndex][fieldName]) {
        delete (validations[valueIndex][fieldName])
        if (!Object.keys(validations[valueIndex]).length) {
          validations.splice(valueIndex, 1)
          // delete (validations[valueIndex])
        }
      }
    }
    let exactDataValue = [...quotaPrices]
    exactDataValue[valueIndex][fieldName] = e.target.value?.toString()
    checkAllDataCompleted(exactDataValue)
    setQuotaPricesValidArr(validations)
    setQuotaPrices(exactDataValue)
  }

  const dataRemoveRecord = (e, valueIndex) => {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }

    let validations = [...quotaPricesValidArr]
    if (!!validations && !!validations.length && !!Object.keys(validations).length
      && !!validations[valueIndex] && !!Object.keys(validations[valueIndex]).length
    ) {
      validations.splice(valueIndex, 1)
    }
    setQuotaPricesValidArr(validations)

    // let exactData = calculationsData[type]
    let exactDataValue = [...quotaPrices]
    exactDataValue.splice(valueIndex, 1)
    setQuotaPrices(exactDataValue)
    checkAllDataCompleted(exactDataValue)
  }

  const tabsAddNewRecord = (e) => {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    setQuotaPrices(prevState => [...prevState, {
      // id: calculationsData.durations?.length,
      price: '',
      price_duration: '',
      quota: ''
    }])
    setQuotaPricesCompleted(false)
  }

  const handleCategoryChange = (event) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    ServiceForm.setFieldValue('category_id', event.target.value.toString())
  }
  const handleHandlerNameChange = (event) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    ServiceForm.setFieldValue('handler_name', event.target.value.toString())
  }

  const [activeValue, setActiveValue] = React.useState(ServiceForm.values.active)
  const handleActiveChange = (event) => {
    setActiveValue(!JSON.parse(event.target.value))
    ServiceForm.setFieldValue('active', !JSON.parse(event.target.value))
  }

  const [allowedTaxTypes, setAllowedTaxTypes] = React.useState(ServiceForm.values.allowed_taxes)
  const handleChange = (event) => {
    setAllowedTaxTypes(event.target.value)
    ServiceForm.setFieldValue('allowed_taxes', event.target.value)
  }

  let errorClass = ServiceForm.errors.description ? ' Mui-error' : ''
  return (
    <ServiceConsumer>
      {({ handlersListLoading, handlersList, categoriesListLoading, categoriesList }) => (
        <form onSubmit={ServiceForm.handleSubmit} noValidate autoComplete="off"
              className={classes.formWrapper}>

          <div className={classes.BasicInfoRow}>
            <InputLabel id="Service.Title"> {<FormattedMessage id='Fields.label.ServiceTitle'/>} </InputLabel>
            <FormControl variant="outlined">
              <TextField
                placeholder={intl.formatMessage({ id: 'Service.placeholder.ServiceTitle' })}
                id="Service.Title"
                type={'text'}
                margin="dense"
                variant="outlined"
                name='title'
                value={ServiceForm.values.title}
                onChange={ServiceForm.handleChange}
                onBlur={ServiceForm.handleBlur}
                helperText={ServiceForm.errors.title && ServiceForm.touched.title && ServiceForm.errors.title}
                error={ServiceForm.errors.title && ServiceForm.touched.title !== undefined}
              />
            </FormControl>
          </div>

          <div className={classes.BasicInfoRow}>
            <InputLabel id="Service.Description"><FormattedMessage id='Fields.label.ServiceDescription'/></InputLabel>
            <FormControl variant="outlined">
              <LanguageConsumer>
                {({ locale }) => (
                  <div className={classes.PageCKContent + errorClass}>
                    {!!isLoading && <SearchLoader loading={true}/>}
                    <CKEditor
                      placeholder={intl.formatMessage({ id: 'Fields.label.ServiceDescription' })}
                      required
                      fullWidth
                      name='description'
                      variant="outlined"
                      data={ServiceForm.values.description}
                      config={{
                        removeButtons: 'About',
                        language: locale
                      }}
                      onChange={(event, editor) => {
                        ServiceForm.setFieldValue('description', event.editor.getData() ? event.editor.getData() : '' || '')
                      }}
                      onloaded={(event) => {
                        setIsLoading(false)
                      }}
                      onOpen={ServiceForm.handleBlur}
                      helperText={ServiceForm.errors.description && ServiceForm.touched.description && ServiceForm.errors.description}
                      error={ServiceForm.errors.description && ServiceForm.touched.description !== undefined}
                    />
                    {ServiceForm.errors.description &&
                    <FormHelperText error required>{ServiceForm.errors.description}</FormHelperText>
                    }
                  </div>
                )}
              </LanguageConsumer>
            </FormControl>
          </div>

          <div className={classes.BasicInfoRow}>
            <InputLabel id="Service.Category"><FormattedMessage id='Fields.label.Category'/>*:</InputLabel>
            <FormControl variant='outlined' margin="dense">
              {!!categoriesListLoading && <ButtonLoader loading={true}/>}
              <Select
                fullWidth
                labelId="Service.Category"
                id="category_id"
                margin="dense"
                MenuProps={{ disableScrollLock: true }}
                name="category_id"
                displayEmpty
                value={!!categoriesList.length ? ServiceForm.values.category_id : ''}
                onChange={handleCategoryChange}
                onBlur={ServiceForm.handleBlur}
                error={ServiceForm.errors.category_id && ServiceForm.touched.category_id !== undefined}
                disabled={!categoriesList.length}
              >
                <MenuItem value=""><FormattedMessage id='Fields.label.Category'/></MenuItem>
                {!!categoriesList.length && categoriesList.map((category) => (
                  <MenuItem key={category.id} value={category.id.toString()}>{category.name}</MenuItem>
                ))}
              </Select>
              {ServiceForm.errors.category_id && ServiceForm.touched.category_id && (
                <FormHelperText error={true}>{ServiceForm.errors.category_id}</FormHelperText>
              )}
            </FormControl>
          </div>

          <div className={classes.BasicInfoRow}>
            <InputLabel id="Service.HandlerName"><FormattedMessage id='Services.List.Table.HandlerName'/>*:</InputLabel>
            <FormControl variant='outlined' margin="dense">
              {!!handlersListLoading && <ButtonLoader loading={true}/>}
              <Select
                fullWidth
                labelId="Service.HandlerName"
                id="handler_name"
                margin="dense"
                MenuProps={{ disableScrollLock: true }}
                name="handler_name"
                displayEmpty
                value={!!handlersList.length ? ServiceForm.values.handler_name : ''}
                onChange={handleHandlerNameChange}
                onBlur={ServiceForm.handleBlur}
                error={ServiceForm.errors.handler_name && ServiceForm.touched.handler_name !== undefined}
                disabled={!handlersList.length}
              >
                <MenuItem value=""><FormattedMessage id='Services.List.Table.HandlerName'/></MenuItem>
                {!!handlersList.length && handlersList.map((handler) => (
                  <MenuItem key={handler.key} value={handler.key.toString()}>{handler.label}</MenuItem>
                ))}
              </Select>
              {ServiceForm.errors.handler_name && ServiceForm.touched.handler_name && (
                <FormHelperText error={true}>{ServiceForm.errors.handler_name}</FormHelperText>
              )}
            </FormControl>
          </div>


          <div className={classes.BasicInfoRow}>
            <InputLabel id="Plan.AllowedTax"><FormattedMessage
              id='Fields.label.AllowedTaxTypes'/>:</InputLabel>
            <FormControl variant="outlined">
              <RadioGroup className={classes.radiosWrapper} aria-label="AllowedTaxTypes" name="allowed_taxes"
                          value={allowedTaxTypes}
                          onChange={handleChange}>
                <FormControlLabel value="" control={<Radio color={'primary'}/>}
                                  label={<FormattedMessage id='Fields.label.AllowedTaxTypes.all'/>}/>
                <FormControlLabel value="custom" control={<Radio color={'primary'}/>}
                                  label={<FormattedMessage id='Fields.label.AllowedTaxTypes.custom'/>}/>
              </RadioGroup>
              <Collapse in={!!allowedTaxTypes} timeout="auto" unmountOnExit>
                <AuthenticatedUserConsumer>
                  {({ bootData }) => (
                    <div className={classes.TaxesWrapper}>
                      <AllowedTaxField fieldName={'allowed_taxes_monthly'} labelKey={'Taxes.Monthly.label'}
                                       allowedTaxTypes={bootData?.allowed_tax_types || []}
                                       formAction={ServiceForm} placeholderKey={'Taxes.Monthly'}/>
                      <AllowedTaxField fieldName={'allowed_taxes_quarterly'} labelKey={'Taxes.Quarterly.label'}
                                       allowedTaxTypes={bootData?.allowed_tax_types || []}
                                       formAction={ServiceForm} placeholderKey={'Taxes.Quarterly'}/>
                      <AllowedTaxField fieldName={'allowed_taxes_midterm'} labelKey={'Taxes.Midterm.label'}
                                       allowedTaxTypes={bootData?.allowed_tax_types || []}
                                       formAction={ServiceForm} placeholderKey={'Taxes.Midterm'}/>
                      <AllowedTaxField fieldName={'allowed_taxes_annually'} labelKey={'Taxes.Annually.label'}
                                       allowedTaxTypes={bootData?.allowed_tax_types || []}
                                       formAction={ServiceForm} placeholderKey={'Taxes.Annually'}/>
                    </div>
                  )}
                </AuthenticatedUserConsumer>
              </Collapse>
            </FormControl>
          </div>

          <div className={classes.BasicInfoRow}>
            <InputLabel id="Service.is_quota_based"><FormattedMessage
              id='Services.List.Table.QuotaBased'/>:</InputLabel>
            <FormControl variant="outlined" className={classes.SwitchWrapper}>
              <FormControlLabel
                label={!!ServiceForm.values.is_quota_based ? intl.formatMessage({ id: 'Services.List.Table.QuotaBased.Option.Active' }) : intl.formatMessage({ id: 'Services.List.Table.QuotaBased.Option.inActive' })}
                value={!!ServiceForm.values.is_quota_based}
                control={
                  <Switch color="primary" checked={ServiceForm.values.is_quota_based}
                          value={!!ServiceForm.values.is_quota_based}/>
                }
                onChange={(event) => {
                  ServiceForm.setFieldValue('is_quota_based', !JSON.parse(event.target.value))
                }}
              />
            </FormControl>
          </div>

          <Collapse in={!!ServiceForm.values.is_quota_based} timeout="auto" unmountOnExit>
            <div className={classes.BasicInfoRow}>
              <InputLabel id="Service.QuotaUnit"> {<FormattedMessage
                id='Fields.label.Service.QuotaUnit'/>} </InputLabel>
              <FormControl variant="outlined">
                <TextField
                  placeholder={intl.formatMessage({ id: 'Service.placeholder.Service.QuotaUnit' })}
                  id="Service.QuotaUnit"
                  type={'text'}
                  margin="dense"
                  variant="outlined"
                  name='quota_unit'
                  value={ServiceForm.values.quota_unit}
                  onChange={ServiceForm.handleChange}
                  onBlur={ServiceForm.handleBlur}
                  helperText={ServiceForm.errors.quota_unit && ServiceForm.touched.quota_unit && ServiceForm.errors.quota_unit}
                  error={ServiceForm.errors.quota_unit && ServiceForm.touched.quota_unit !== undefined}
                />
              </FormControl>
            </div>

            <div className={classes.BasicInfoRow}>
              <InputLabel id="Service.Quota" className={classes.labelLineHeight}><FormattedMessage
                id='Services.List.Table.Quota'/>*:</InputLabel>
              <FormControl variant="outlined">
                {quotaPrices?.map((quotaPrice, index) => (
                  <React.Fragment key={index}>
                    <div className={classes.pricesWrapper + ' quota-price-row'}>
                      <TextField
                        label={intl.formatMessage({ id: 'Fields.label.Quota.quota' }, {
                          span: chunks => <span className={classes.required}>{chunks}</span>
                        })}
                        id={`Service-${index}-quota`}
                        name={`Service-${index}-quota`}
                        type={'number'}
                        margin="dense"
                        variant="outlined"
                        value={quotaPrice?.quota || ''}
                        onChange={e => handleQuotaPriceRecordChange(e, index, 'quota')}
                        onBlur={ServiceForm.handleBlur}
                        error={(!!quotaPricesValidArr[index] && !!quotaPricesValidArr[index]?.quota) || !!quotaPricesDuplicated[index]}
                        helperText={!!quotaPricesValidArr[index] && !!quotaPricesValidArr[index]?.quota && intl.formatMessage({ id: 'validationSchema.required' })}
                        InputLabelProps={{
                          shrink: true
                        }}
                        InputProps={{
                          inputProps: {
                            min: 1
                          },
                          endAdornment: <InputAdornment position="end">{ServiceForm.values.quota_unit}</InputAdornment>
                        }}
                      />
                      <TextField
                        label={intl.formatMessage({ id: 'Fields.label.Quota.price' }, {
                          span: chunks => <span className={classes.required}>{chunks}</span>
                        })}
                        id={`Service-${index}-price`}
                        name={`Service-${index}-price`}
                        type={'number'}
                        margin="dense"
                        variant="outlined"
                        value={quotaPrice?.price || ''}
                        onChange={e => handleQuotaPriceRecordChange(e, index, 'price')}
                        onBlur={ServiceForm.handleBlur}
                        error={!!quotaPricesValidArr[index] && !!quotaPricesValidArr[index]?.price}
                        helperText={!!quotaPricesValidArr[index] && !!quotaPricesValidArr[index]?.price && intl.formatMessage({ id: 'validationSchema.required' })}
                        InputLabelProps={{
                          shrink: true
                        }}
                        InputProps={{
                          inputProps: {
                            min: 1
                          },
                          endAdornment: <InputAdornment position="end"><FormattedMessage id='egp'/></InputAdornment>
                        }}
                      />

                      <FormControl variant='outlined' margin="dense"
                                   error={(!!quotaPricesValidArr[index] && !!quotaPricesValidArr[index]?.price_duration) || !!quotaPricesDuplicated[index]}>
                        <InputLabel id={`Service-label-${index}-price_duration`}
                                    htmlFor={`Service-${index}-price_duration`}><FormattedMessage
                          id='Fields.label.Quota.price_duration'/> <span
                          className={classes.required}>*</span></InputLabel>
                        <Select
                          fullWidth
                          required
                          label={intl.formatMessage({ id: 'Fields.label.Quota.price_duration_label' }, {
                            span: chunks => <span className={classes.required}>{chunks}</span>
                          })}
                          labelId={`Service-label-${index}-price_duration`}
                          name={`Service-${index}-price_duration`}
                          id={`Service-${index}-price_duration`}
                          MenuProps={{ disableScrollLock: true }}
                          value={!!priceDurations.length ? quotaPrice?.price_duration : ''}
                          onChange={e => handleQuotaPriceRecordChange(e, index, 'price_duration')}
                          onBlur={ServiceForm.handleBlur}
                        >
                          <MenuItem value=""><FormattedMessage id='Fields.label.Quota.price_duration'/></MenuItem>
                          {!!priceDurations.length && priceDurations.map((duration) => (
                            <MenuItem key={duration.key} value={duration.key.toString()}>{duration.label}</MenuItem>
                          ))}
                        </Select>
                        {!!quotaPricesValidArr[index] && !!quotaPricesValidArr[index]?.price_duration && (
                          <FormHelperText error={true}><FormattedMessage
                            id='validationSchema.required'/></FormHelperText>
                        )}
                      </FormControl>

                      <div className={classes.removeWrapper}>
                        <Button variant="contained" color="secondary" className={classes.removeRecord}
                                startIcon={<DeleteForeverIcon/>}
                                onClick={e => dataRemoveRecord(e, index)}>
                          <FormattedMessage id="Service.QuotaPrice.remove"/>
                        </Button>
                      </div>
                    </div>
                    {!!quotaPricesDuplicated[index] &&
                    <FormHelperText error><FormattedMessage
                      id='validationSchema.service.quotaPrice.duplicated'/></FormHelperText>
                    }
                  </React.Fragment>
                ))}
                <Button className={classes.AddNewRecord} variant="contained" color="primary"
                        onClick={e => tabsAddNewRecord(e, 'durations')}
                        disabled={!!quotaPricesValidArr?.filter(valid => !!valid).length || !quotaPricesCompleted || !!quotaPricesDuplicated?.filter(dup => !!dup).length}>
                  <FormattedMessage id="Service.QuotaPrice.addRecord"/>
                </Button>
                <FormHelperText
                  error>{ServiceForm.errors.quotaPrices && ServiceForm.touched.quotaPrices !== undefined &&
                <FormattedMessage id='validationSchema.required'/>}</FormHelperText>

              </FormControl>
            </div>

            <TopUps ServiceForm={ServiceForm}
                    topups={currentDate?.topups || []}
                    setTopUpsCompleted={setTopUpsCompleted}
                    topUpsCompleted={topUpsCompleted}/>

          </Collapse>

          <Collapse in={!ServiceForm.values.is_quota_based} timeout="auto" unmountOnExit>
            <div className={classes.BasicInfoRow}>
              <InputLabel id="Service.Prices"><FormattedMessage id='Services.List.Table.Prices'/>*:</InputLabel>
              <FormControl variant="outlined">
                <div className={classes.pricesWrapper}>
                  <TextField
                    label={intl.formatMessage({ id: 'Service.Prices.Monthly' })}
                    id="price_monthly"
                    type={'number'}
                    margin="dense"
                    variant="outlined"
                    name='price_monthly'
                    value={ServiceForm.values.price_monthly}
                    onChange={ServiceForm.handleChange}
                    onBlur={ServiceForm.handleBlur}
                    helperText={ServiceForm.errors.price_monthly && ServiceForm.touched.price_monthly && ServiceForm.errors.price_monthly}
                    error={ServiceForm.errors.price_monthly && ServiceForm.touched.price_monthly !== undefined}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      inputProps: {
                        min: 1
                      },
                      endAdornment: <InputAdornment position="end"><FormattedMessage id='egp'/></InputAdornment>
                    }}
                  />
                  <TextField
                    label={intl.formatMessage({ id: 'Service.Prices.Quarterly' })}
                    id="price_quarterly"
                    type={'number'}
                    margin="dense"
                    variant="outlined"
                    name='price_quarterly'
                    value={ServiceForm.values.price_quarterly}
                    onChange={ServiceForm.handleChange}
                    onBlur={ServiceForm.handleBlur}
                    helperText={ServiceForm.errors.price_quarterly && ServiceForm.touched.price_quarterly && ServiceForm.errors.price_quarterly}
                    error={ServiceForm.errors.price_quarterly && ServiceForm.touched.price_quarterly !== undefined}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      inputProps: {
                        min: 1
                      },
                      endAdornment: <InputAdornment position="end"><FormattedMessage id='egp'/></InputAdornment>
                    }}
                  />
                  <TextField
                    label={intl.formatMessage({ id: 'Service.Prices.Midterm' })}
                    id="price_midterm"
                    type={'number'}
                    margin="dense"
                    variant="outlined"
                    name='price_midterm'
                    value={ServiceForm.values.price_midterm}
                    onChange={ServiceForm.handleChange}
                    onBlur={ServiceForm.handleBlur}
                    helperText={ServiceForm.errors.price_midterm && ServiceForm.touched.price_midterm && ServiceForm.errors.price_midterm}
                    error={ServiceForm.errors.price_midterm && ServiceForm.touched.price_midterm !== undefined}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      inputProps: {
                        min: 1
                      },
                      endAdornment: <InputAdornment position="end"><FormattedMessage id='egp'/></InputAdornment>
                    }}
                  />
                  <TextField
                    label={intl.formatMessage({ id: 'Service.Prices.Annually' })}
                    id="price_annually"
                    type={'number'}
                    margin="dense"
                    variant="outlined"
                    name='price_annually'
                    value={ServiceForm.values.price_annually}
                    onChange={ServiceForm.handleChange}
                    onBlur={ServiceForm.handleBlur}
                    helperText={ServiceForm.errors.price_annually && ServiceForm.touched.price_annually && ServiceForm.errors.price_annually}
                    error={ServiceForm.errors.price_annually && ServiceForm.touched.price_annually !== undefined}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      inputProps: {
                        min: 1
                      },
                      endAdornment: <InputAdornment position="end"><FormattedMessage id='egp'/></InputAdornment>
                    }}
                  />
                </div>
                <FormHelperText error>{ServiceForm.dirty &&
                (ServiceForm.touched.price_monthly ||
                  ServiceForm.touched.price_quarterly ||
                  ServiceForm.touched.price_midterm ||
                  ServiceForm.touched.price_annually) &&
                ServiceForm.errors.pricesPlan}</FormHelperText>
              </FormControl>
            </div>
          </Collapse>

          <div className={classes.BasicInfoRow}>
            <InputLabel id="Service.Active"><FormattedMessage
              id='Services.List.Table.active'/>:</InputLabel>
            <FormControl variant="outlined" className={classes.SwitchWrapper}>
              <FormControlLabel
                label={activeValue ? intl.formatMessage({ id: 'Services.List.Table.Active.Option.Active' }) : intl.formatMessage({ id: 'Services.List.Table.Active.Option.inActive' })}
                value={activeValue ? true : false}
                control={
                  <Switch color="primary" checked={activeValue} value={activeValue ? true : false}/>
                }
                onChange={handleActiveChange}
              />
            </FormControl>
          </div>

          <div className={classes.SubmitRow}>
            <button type="submit" disabled={ServiceForm.isSubmitting || !ServiceForm.isValid || !topUpsCompleted}
                    className={classes.AddAdminSubmit}>
              <FormattedMessage id='AdditionalInfo.button.submit'/>
            </button>
            <Button onClick={() => history.push(NamedRoutes.subscription.service.list)} color="primary">
              <FormattedMessage id='ChangePhone.DialogActions.cancel'/>
            </Button>
          </div>
          {ServiceForm.isSubmitting && <FormLoader loading={true}/>}
        </form>
      )}
    </ServiceConsumer>
  )
}

export default ServiceForm
